const setSMSProviders = function (state, data) {
  const { conversationChannel } = data
  state.smsProviders = []
  state.smsProviders = [conversationChannel?.SMS].flat() ?? []
}

export default setSMSProviders
